import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Observable } from "rxjs";
import { OrderAPI } from "@/api/order.api";

const api = new OrderAPI();

const list = (params: any): Observable<any> => {
  return api.list(params);
}

const show = (id: number): AxiosObservable<any> => {
  return api.show(id);
};

const showPublic = (secretToken: string): AxiosObservable<any> => {
  return api.showPublic(secretToken);
};

const showPaymentsGroup = (group: string): AxiosObservable<any> => {
  return api.showPaymentsGroup(group);
};

const createAutovistoria = (
  solicitaionId: string,
  body: object
): AxiosObservable<any> => {
  return api.createAutovistoria(solicitaionId, body);
};

const getAllAutovistoria = (solicitaionId: string): AxiosObservable<any> => {
  return api.getAllAutovistoria(solicitaionId);
};

const detailsAutovistoria = (
  solicitaionId: string,
  key: string
): AxiosObservable<any> => {
  return api.detailsAutovistoria(solicitaionId, key);
};

const updateApproveImages = (
  solicitaionId: string,
  inspectionKey: string,
  key: string,
  body: object
): AxiosObservable<any> => {
  return api.updateApproveImages(solicitaionId, inspectionKey, key, body);
};

const updateVehicleInformation = (
  solicitaionId: string,
  inspectionKey: string,
  key: string,
  body: object
): AxiosObservable<any> => {
  return api.updateVehicleInformation(
    solicitaionId,
    inspectionKey,
    key,
    body
  );
};

const deferAutovistoria = (
  solicitaionId: string,
  inspectionKey: string
): AxiosObservable<any> => {
  return api.deferAutovistoria(solicitaionId, inspectionKey);
};

const denyAutovistoria = (
  solicitaionId: string,
  inspectionKey: string,
  rejectReason: string
): AxiosObservable<any> => {
  return api.denyAutovistoria(solicitaionId, inspectionKey, rejectReason);
};

const updateItemChecklist = (
  solicitaionId: string,
  inspectionKey: string,
  key: string,
  body: object
): AxiosObservable<any> => {
  return api.updateItemChecklist(solicitaionId, inspectionKey, key, body);
};

const finishChecklist = (
  solicitaionId: string,
  inspectionKey: string,
  key: string
): AxiosObservable<any> => {
  return api.finishChecklist(solicitaionId, inspectionKey, key);
};
const resendAutovistoria = (
  solicitaionId: string,
  key: string
): AxiosObservable<any> => {
  return api.resendAutovistoria(solicitaionId, key);
};
const sendEvidenceRefusend = (
  solicitaionId: string,
  key: string
): AxiosObservable<any> => {
  return api.sendEvidenceRefusend(solicitaionId, key);
};

const updateAutovistoria = (
  solicitaionId: string,
  key: string,
  body: object
): AxiosObservable<any> => {
  return api.updateAutovistoria(solicitaionId, key, body);
};

const generateReport = (
  solicitaionId: string,
  key: string
): AxiosObservable<any> => {
  return api.generateReport(solicitaionId, key);
};

const uploadReport = (
  solicitaionId: string,
  key: string,
  content: File
): AxiosObservable<any> => {

  return api.uploadReport(solicitaionId, key, content);
};

const cancel = (id: number, reason: string): AxiosObservable<any> => {
  return api.cancel(id, reason);
};

const analyse = (id: number): AxiosObservable<any> => {
  return api.analyse(id);
};

const approve = (id: number): AxiosObservable<any> => {
  return api.approve(id);
};

const refuse = (id: number, reason: string): AxiosObservable<any> => {
  return api.refuse(id, reason);
};

const pending = (id: number): AxiosObservable<any> => {
  return api.pending(id);
};

const listStatus = (): AxiosObservable<any> => {
  return api.listStatus();
};

const listDocuments = (orderId: number): AxiosObservable<any> => {
  return api.listDocuments(orderId);
};

const listDocumentsPublic = (secretToken: string): AxiosObservable<any> => {
  return api.listDocumentsPublic(secretToken);
};

const bulkCreate = (body: any): Observable<any> => {
  return api.bulkCreate(body)
}

const createCompanyRegistrationRenewal = (body: any): Observable<any> => {
  return api.createCompanyRegistrationRenewal(body)
}

const createCompanyRegistration = (body: any): Observable<any> => {
  return api.createCompanyRegistration(body)
}

const createVehicleInclusion = (body: any): Observable<any> => {
  return api.createVehicleInclusion(body)
}

export default {
  list,
  show,
  showPublic,
  showPaymentsGroup,
  createAutovistoria,
  getAllAutovistoria,
  detailsAutovistoria,
  updateApproveImages,
  updateVehicleInformation,
  deferAutovistoria,
  denyAutovistoria,
  updateItemChecklist,
  resendAutovistoria,
  sendEvidenceRefusend,
  updateAutovistoria,
  finishChecklist,
  generateReport,
  uploadReport,
  cancel,
  listStatus,
  listDocuments,
  listDocumentsPublic,
  analyse,
  approve,
  refuse,
  pending,
  bulkCreate,
  createCompanyRegistrationRenewal,
  createCompanyRegistration,
  createVehicleInclusion
};
